<script>
    import Fa from "svelte-fa";
    import { faCheck } from "@fortawesome/free-solid-svg-icons";
    import { createEventDispatcher } from "svelte";
  
    export let gold = false;
    export let referredUsers = 0;
    export let signedIn = false;
    export let devMode = false;
  
    const dispatch = createEventDispatcher();
  
    function closeModal() {
      dispatch("close");
    }
    function handleCancelGold() {
      dispatch("cancelGold");
    }
    function handleClaimPlatinum() {
      dispatch("claimPlatinum");
    }
  </script>
  
  <div class="subscription-overlay" on:click={closeModal}>
    <div
      class="subscription-dialog-wrapper"
      on:click|stopPropagation
    >
      <!-- GOLD COLUMN -->
      <div class="plan-box gold-plan">
        <h1 class="modal-title">
          AI Cloaker <span class="gold-shimmer">Gold</span>
        </h1>
        <p class="modal-subtitle">
          You’re currently on <strong>Gold</strong>.
        </p>
  
        <div class="subscription-features">
          <p class="feature-heading">Gold Plan Features</p>
          <ul class="subscription-feature-list">
            <li>
              <Fa icon={faCheck} class="icon" />
              Unlimited AI Rewrites
            </li>
            <li>
              <Fa icon={faCheck} class="icon" />
              Advanced Cloaking Options
            </li>
            <li>
              <Fa icon={faCheck} class="icon" />
              Priority Support
            </li>
          </ul>
        </div>
  
        <button class="cancel-btn" on:click={handleCancelGold}>
          Cancel Gold
        </button>
      </div>
  
      <!-- PLATINUM COLUMN -->
      <div class="plan-box platinum-plan">
        <h1 class="modal-title">
          AI Cloaker <span class="platinum-shimmer">Platinum</span>
        </h1>
        <p class="modal-subtitle">
          Unlock <strong>Platinum</strong> by referring 5 new Gold users!
        </p>
  
        <div class="subscription-features">
          <p class="feature-heading">Includes everything in Gold, plus:</p>
          <ul class="subscription-feature-list">
            <li>
              <Fa icon={faCheck} class="icon" />
              <strong>20 shareable credits</strong>
            </li>
            <li>
              <Fa icon={faCheck} class="icon" />
              Exclusive Platinum badge
            </li>
            <li>
              <Fa icon={faCheck} class="icon" />
              All <strong>Gold</strong> benefits, <u>free!</u>
            </li>
          </ul>
        </div>
        <p class="agreement-row">
          To refer a user, simply share your referral code and have them enter it 
          in the "Referral Code" box when they subscribe.
        </p>
  
        <button
          class="btn btn-primary platinum-btn"
          on:click={handleClaimPlatinum}
          disabled={referredUsers < 5}
        >
          Referred Users: {referredUsers}/5
        </button>
        {#if referredUsers < 5}
          <p style="font-size:0.85rem; color:#bbb; margin-top:0.5rem">
            You need 5 referrals before you can claim Platinum.
          </p>
        {/if}
      </div>
  
      <button class="modal-close" on:click={closeModal}>X</button>
    </div>
  </div>
  
  <style>
    .subscription-overlay {
      position: fixed;
      inset: 0;
      background: rgba(10, 11, 14, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
    }
    .subscription-dialog-wrapper {
      display: flex;
      flex-direction: row;
      background: #1a1c22;
      border: 1px solid #424867;
      border-radius: 10px;
      max-width: 850px;
      width: 95%;
      padding: 2rem;
      position: relative;
      justify-content: center;
      gap: 2rem;
    }
    @media (max-width: 850px) {
      .subscription-dialog-wrapper {
        flex-direction: column;
        align-items: center;
      }
    }
    .plan-box {
      flex: 1;
      min-width: 280px;
      background-color: #0a0b0e;
      border: 1px solid #424867;
      border-radius: 8px;
      padding: 1.5rem;
      text-align: center;
    }
    .modal-title {
      font-size: 1.6rem;
      margin-bottom: 0.75rem;
      background: linear-gradient(120deg, #646cff, #ff6b6b);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .modal-subtitle {
      color: #94a3b8;
      margin-bottom: 1rem;
    }
    .subscription-features {
      text-align: left;
      background-color: #1a1c22;
      border: 1px solid #424867;
      border-radius: 8px;
      padding: 1rem;
      margin-bottom: 1.5rem;
    }
    .feature-heading {
      font-size: 1rem;
      font-weight: 600;
      margin: 0;
      color: #e2e8f0;
    }
    .subscription-feature-list {
      list-style: none;
      padding: 0;
      margin-top: 0.75rem;
    }
    .subscription-feature-list li {
      display: flex;
      align-items: center;
      gap: 0.4rem;
      margin: 0.5rem 0;
      color: #ccc;
    }
    .subscription-feature-list li .icon {
      color: #8ef1a3;
    }
    .agreement-row {
      margin-bottom: 1rem;
    }
    .modal-close {
      position: absolute;
      top: 0.5rem;
      right: 0.75rem;
      background: none;
      border: none;
      color: #999;
      font-size: 1.2rem;
      cursor: pointer;
    }
    .gold-plan {
      border: 1px solid #f0b828;
    }
    .platinum-plan {
      border: 1px solid #b5b6b7;
    }
    .gold-shimmer {
      background: linear-gradient(
        90deg,
        #ffd700,
        #ffc300,
        #ff8c00,
        #ffc300,
        #ffd700
      );
      background-size: 300% auto;
      animation: shine 4s linear infinite;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
    }
    .platinum-shimmer {
      background: linear-gradient(
        90deg,
        #c0c0c0,
        #d3d3d3,
        #a8a8a8,
        #d3d3d3,
        #c0c0c0
      );
      background-size: 300% auto;
      animation: shine 4s linear infinite;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
    }
    @keyframes shine {
      0% {
        background-position: -200% center;
      }
      100% {
        background-position: 200% center;
      }
    }
    .cancel-btn {
      background: #ff6b6b;
      color: #fff;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      padding: 0.5rem 1rem;
      margin-top: 0.5rem;
    }
    .cancel-btn:hover {
      background: #ff4c4c;
    }
    .btn.btn-primary {
      width: 100%;
    }
  </style>
  